import axios from 'axios'
import apiUrl from '../_const'

export default {
  getAllGroups () {
    return axios.get(apiUrl.SECURITYGROUPS_URL, {
      headers: {'X-Auth-Jwt': window.sessionStorage.jwt}
    }).catch((error) => {
      return new Error(error)
    })
  },
  getGroup ({commit}, id) {
    return axios.get(apiUrl.SECURITYGROUPS_URL + '/' + id, {
      headers: {'X-Auth-Jwt': window.sessionStorage.jwt}
    }).catch((error) => {
      return new Error(error)
    })
  },
  deleteGroup ({commit}, id) {
    return axios.delete(apiUrl.SECURITYGROUPS_URL + '/' + id, {
      headers: {'X-Auth-Jwt': window.sessionStorage.jwt}
    }).catch((error) => {
      return new Error(error)
    })
  },
  createNewGroup ({commit}, data) {
    return axios.post(apiUrl.SECURITYGROUPS_URL, {
      name: data.name,
      description: data.description
    }, {
      headers: {'X-Auth-Jwt': window.sessionStorage.jwt}
    }).catch((error) => {
      return new Error(error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/openstack/modules/securitygroups.js